import { useTranslation } from "react-i18next";
import { useTransferGroupOwner, useSetGroupAdmin } from "@/components/chat/GroupOperation";
import { SessionSettingsType, TransferGroupAdminSource } from "@/types/chat/enum";
import React, { ReactNode, useCallback, useEffect, useMemo, useState } from "react";
import IconFont from "@/components/icon";
import { Drawer, message, Switch, Checkbox, Select } from "antd";
import {
  getSessionSettingValue,
  isGroupSetAlias,
  isGroupChatVisibleUnit,
  isGroupVisibleUnit,
  isBannedPostGroupSession,
  isCardViewGroupSession,
  isIdentityApproveRuleGroupSession,
  isGroupvisiblePost,
  isGroupShowMsgTime,
  isGroupShowMsgReply,
  isCrossPlatformGroupSession,
  isGroupAIMerge
} from "@/utils/chat/message";
import {
  checkApprovalRuleDisabled,
  checkCanSearchDisabled,
  checkCanTransferGroupOwner,
  checkCanSetAdmin,
  checkNeedVerifyDisabled,
  checkCanDissolutionGroup
} from "@/utils/chat/group";
import classnames from "classnames";
import isNull from "lodash/isNull";
import { Employee, GroupAttribute, Session, SessionProps } from "@/types/chat";
import { sessionSetting } from "@/server/im/SessionService";
import Context from "@/components/chat/context";
// sxl 连续点击switch 节流
import { debounce, throttle } from "lodash";
import bus from "@/utils/bus";
import { connect } from "dvajs";
import ChatState, { ChatConnectState } from "@/types/chat/State";
import GroupSubAdmin from "../GroupSubAdmin";
import i18n from "@/i18n";
import NetworkCheck, { UseCheckType } from "@/utils/NetworkCheck";
import config, { ChatConfig, getNetCheckUrl } from "@/config/config";
import Prompt from "@/baseComponents/ModalComponent/prompt";
import { isBusinessGroup } from "@/utils/chat/session";
import ImService from "@/server/ImService";
import { closeChatWindow } from "@/utils/chat/index";
import { crossAppSwitch } from "@/utils/tools";
import { useHistory } from "react-router-dom";
import GroupRecord from "./GroupRecord/GroupRecord";
import { isFocusEnv } from "@/utils";
import { getGroupSizeLimitRule, getCommonLimitRule } from "@/api/egroup";
interface Props {
  selectedSession: Session;
  sessionMembers: Partial<Employee>[];
  loadSessionMembers: Function;
}

type IProps = Readonly<Props>;

export function GroupSettingItem({
  title,
  desc,
  children,
  onClick,
  clstag,
  style,
  boldTitle = true,
  checkboxStyle = false
}: {
  title: string;
  desc?: string;
  children: ReactNode;
  onClick?: () => void;
  clstag?: string;
  style?: any;
  boldTitle?: boolean;
  checkboxStyle?: boolean;
}) {
  const descPart = useMemo(() => {
    if (desc) {
      return (
        <div className="item-desc">
          <p>{desc}</p>
        </div>
      );
    }
    return null;
  }, [desc]);

  const classes = classnames({
    "group-management-item": true,
    "has-desc": !isNull(descPart),
    "checkbox-style": checkboxStyle
  });

  return (
    <div className={classes} onClick={onClick} clstag={clstag} style={style}>
      <div className="group-management-item-title">
        <p style={{ fontWeight: boldTitle ? 500 : 400 }}>{title}</p>
        {descPart}
      </div>
      <div className="group-management-item-children">{children}</div>
    </div>
  );
}

/**
 * 群设置各个配置选项操作开发组件
 * type 开关类型
 * reverse 是否反置开关  reverse:true 0开1关  reverse:false 1开0关
 * @param props
 * @constructor
 */
function SettingSwitchComp(
  props: IProps & {
    type: SessionSettingsType;
    disabled?: boolean;
    reverse?: boolean;
    clsTag?: [string, string];
    checkboxStyle?: boolean;
  }
) {
  const {
    selectedSession,
    type,
    reverse,
    disabled,
    clsTag = ["", ""],
    checkboxStyle = false
  } = props;
  const { t } = useTranslation("chat");
  const value = getSessionSettingValue(selectedSession, type);
  const [checked, setChecked] = useState(value);
  const [isloading, setLoading] = useState(false);
  useEffect(() => {
    setChecked(value);
  }, [value]); // eslint-disable-line

  const netServer = NetworkCheck.getInstance({
    url: getNetCheckUrl(),
    checkType: UseCheckType.API
  });

  // switch滑动添加到置顶
  const onChange = useCallback(
    async (checked: boolean) => {
      try {
        setLoading(true);
        const onLine = await netServer.checkNet();
        if (!onLine) {
          message.error(i18n.t("Network Error"));
        }
        const iChecked = reverse ? !checked : checked;
        const result = await sessionSetting(type, selectedSession.sessionId, iChecked);
        if (isNull(result)) {
          message.error(t("failed"));
        }
        setLoading(false);
      } catch (e) {
        message.error(t("failed"));
      }
    },
    [selectedSession.sessionId, t, type, reverse] // eslint-disable-line
  );

  const onChangeForCheckbox = useCallback(
    async (e: any) => {
      try {
        // setLoading(true);
        const onLine = await netServer.checkNet();
        let checked = e.target.checked;
        if (!onLine) {
          message.error(i18n.t("Network Error"));
        }
        console.log("value====checked", e);

        // const iChecked = reverse ? !checked : checked;
        const result = await sessionSetting(type, selectedSession.sessionId, checked);
        if (isNull(result)) {
          message.error(t("failed"));
        }
        // setLoading(false);
      } catch (e) {
        message.error(t("failed"));
      }
    },
    [selectedSession.sessionId, t, type, reverse] // eslint-disable-line
  );
  return checkboxStyle ? (
    <Checkbox
      style={{ marginRight: "6px" }}
      checked={checked}
      // disabled={isloading}
      onChange={onChangeForCheckbox}
      clstag={clsTag[checked ? 1 : 0]}
    />
  ) : (
    <Switch
      disabled={disabled}
      checked={checked}
      loading={isloading}
      onClick={debounce(onChange, 200)}
      clstag={clsTag[checked ? 1 : 0]}
    />
  );
}
export const SettingSwitch = connect(mapStateToProps, mapDispatchToProps)(SettingSwitchComp);

// 灰线
export function GrayLine({ title }: { title: string }) {
  return <div className="group-management-gray-line">{title}</div>;
}

function GroupManager(
  props: IProps & {
    visible: boolean;
    onClose: () => void;
    updateSessionData: Function;
    updateSelectedSession: Function;
  }
) {
  const {
    visible,
    onClose,
    selectedSession,
    loadSessionMembers,
    updateSessionData,
    updateSelectedSession
  } = props;

  const {
    currentEmployee,
    groupRosters,
    userData,
    groupRosterIdentity,
    aiMergeOptions
  } = React.useContext(Context);

  const [visibleSetAdmin, setVisibleSetAdmin] = useState(false);
  const [limitOpts, setLimitOpts] = useState([]);
  const [allowMuteGroup, setAllowMuteGroup] = useState(true);

  const { t } = useTranslation("chat");

  const history = useHistory();

  const canDissolutionGroup = useMemo(() => {
    return checkCanDissolutionGroup({ selectedSession, groupRosterIdentity });
  }, [groupRosterIdentity, selectedSession]);

  useEffect(() => {
    const { ddAppId = "", userId = "", teamUserInfo } = userData;
    const { teamId = "" } = teamUserInfo;
    getGroupSizeLimitRule({ app: ddAppId, pin: userId, teamId }).then((limitRule: any) => {
      const { ruleGradient = [] } = limitRule;
      setLimitOpts(ruleGradient);
    });
    getCommonLimitRule({ app: ddAppId, pin: userId, teamId }).then((content) => {
      const allowMuteData = content.allowMuteGroup;
      if (typeof allowMuteData === "boolean") {
        setAllowMuteGroup(allowMuteData);
      }
    });
  }, []);
  // 解散普通组
  const dissolutionNormalGroup = () => {
    Prompt({
      icon: <IconFont type="iconic_failure" style={{ color: "#F96137" }} />,
      title: t("dismiss-group-reminder"),
      content: t("dismiss-group-prompt"),
      cancelText: t("cancelText"),
      onOk: confirmDissolution,
      okText: t("determine")
    });
  };

  // 触发解散群组弹框
  const dissolutionGroup = () => {
    if (isBusinessGroup(selectedSession)) {
      // 解散相关日程、任务组
      const info = selectedSession.info as any;
      if (info.businessId) {
        bus.emit("im_special_disband_group_event", {
          businessId: info.businessId,
          businessType: info.business,
          callback: confirmDissolution,
          type: "dismiss"
        });
        return;
      }
    }
    dissolutionNormalGroup();
  };

  const confirmDissolution = useCallback(async () => {
    if (selectedSession.sessionId || selectedSession.gid) {
      const instance = ImService.getInstance();
      const result = await instance.disbandGroup(
        selectedSession.sessionId || selectedSession.gid || ""
      );
      if (result) {
        // console.log('解散群', selectedSession.sessionId || selectedSession.gid || '');
        await instance.getDbGroup({
          gid: selectedSession.sessionId || selectedSession.gid || ""
        });
        closeChatWindow();
        const session = { ...selectedSession };
        session.info = { ...((selectedSession.info || {}) as GroupAttribute), status: 0 };
        updateSessionData({ session });
        updateSelectedSession({ selectedSession: {} });
        // bus.emit("chat:session-list", [session]);
        history.push("/messages");
        message.success(t("success"));
      }
    }
  }, [selectedSession.gid, selectedSession.sessionId, t]); // eslint-disable-line

  // 转让群主功能
  const transferGroupAdmin = useTransferGroupOwner({
    selectedSession,
    currentEmployee,
    groupRosters,
    userData,
    operateType: TransferGroupAdminSource.GROUP_MANAGER_OPERATE,
    callback: () => {
      let groupInfo = selectedSession.info as GroupAttribute;
      bus.emit("chat:group:transferGroupOwner", groupInfo.gid);
    }
  });

  // 添加移除管理员功能 方案1
  const setGroupAdminFn = useSetGroupAdmin({
    selectedSession,
    currentEmployee,
    groupRosters,
    userData,
    loadSessionMembers
  });

  // 添加移除管理员功能 方案2
  // const setGroupAdminFn = () => {
  //     setVisibleSetAdmin(true);
  // };

  const canTransferGroupOwner = useMemo(() => {
    return checkCanTransferGroupOwner({ selectedSession, groupRosterIdentity });
  }, [selectedSession, groupRosterIdentity]);

  const canSetAdmin = useMemo(() => {
    return checkCanSetAdmin({ selectedSession, groupRosterIdentity });
  }, [selectedSession, groupRosterIdentity]);

  const approvalRuleDisabled = useMemo(() => {
    return checkApprovalRuleDisabled({ selectedSession });
  }, [selectedSession]);

  const canSearchDisabled = useMemo(() => {
    return checkCanSearchDisabled({ selectedSession });
  }, [selectedSession]);

  // 智能聚合
  const canAIMergeDisabled = useMemo(() => {
    // 网页端屏蔽
    if (!isFocusEnv() || !config[ChatConfig.CHAT_MESSAGE_AI_MERGE]) {
      return false;
    }
    // 开启或者有白名单人物
    const { whitelist = [] } = aiMergeOptions || {};
    const users = groupRosters.filter((r: any) => whitelist.includes(r?.user?.pin));
    return isGroupAIMerge(selectedSession) || (users?.length || 0) > 0;
  }, [aiMergeOptions, groupRosters, selectedSession]);

  const needVerifyDisabled = useMemo(() => {
    return checkNeedVerifyDisabled({ selectedSession });
  }, [selectedSession]);

  const isTaskGroup = useMemo(() => {
    return selectedSession.info?.business === "work";
  }, [selectedSession]);

  const isScheduleGroup = useMemo(() => {
    return selectedSession.info?.business === "schedule";
  }, [selectedSession]);

  const titleNode = useMemo(() => {
    return (
      <div>
        <IconFont
          type="iconwin_left"
          className="group-management-icon-arrow app-region-none"
          onClick={onClose}
        />
        <span className="management-title">{t("group_management")}</span>
      </div>
    );
  }, [onClose, t]);

  const adminNum = useMemo(() => {
    return (
      groupRosters?.filter((session: any) => session.identity === "sub_administrator")?.length || 0
    );
  }, [groupRosters]);
  const groupMemberLimit = useMemo(() => {
    console.log("groupMemberLimit:", selectedSession);
    const info: any = selectedSession.info;
    return info.max || 0;
  }, [selectedSession.info]);

  const renderLimitValue = useMemo(() => {
    if (limitOpts.find((itm: any) => itm.limit === groupMemberLimit)) {
      return groupMemberLimit;
    } else {
      return `${groupMemberLimit}人`;
    }
  }, [groupMemberLimit, limitOpts]);
  return (
    <>
      <Drawer
        className="group-manager-right-drawer"
        getContainer={document.querySelector("#chat-right-container-change-set") as HTMLElement}
        title={titleNode}
        placement="right"
        width="340px"
        height="100%"
        mask={false}
        destroyOnClose={true}
        closable={false}
        onClose={onClose}
        visible={visible}
        footer={
          <div className="group-out">
            {canDissolutionGroup && (
              <button
                onClick={dissolutionGroup}
                clstag="pageclick|keycount|Xtbg_Msg_Setting|DisbandGroup"
              >
                {t("disband_group")}
              </button>
            )}
          </div>
        }
        style={{ position: "absolute", right: 0 }}
      >
        {/* 群信息管理 */}
        {/* 设置 全员可修改群信息 暂时关掉 */}
        {/* {!isSpecialProjectMasterSession(selectedSession) && ( */}
        {/*    <div> */}
        {/*        <GrayLine title={t('group_management_config.group_info_management')} /> */}
        {/*        <GroupSettingItem */}
        {/*            title={t('group_management_config.permission_check.title')} */}
        {/*            desc={t('group_management_config.permission_check.desc')} */}
        {/*        > */}
        {/*            <SettingSwitch */}
        {/*                selectedSession={selectedSession} */}
        {/*                type={SessionSettingsType.PERMISSION_CHECK} */}
        {/*                clsTag={[ */}
        {/*                    'pageclick|keycount|focus_chat_02_1615797535989|15', */}
        {/*                    'pageclick|keycount|focus_chat_02_1615797535989|16', */}
        {/*                ]} */}
        {/*            /> */}
        {/*        </GroupSettingItem> */}
        {/*    </div> */}
        {/* )} */}
        {/* 成员管理 */}
        <GrayLine title={t("group_management_config.group_member_management")} />
        {/* 设置全员禁言 */}
        <GroupSettingItem
          title={t("group_management_config.member_no_talking.title")}
          desc={
            allowMuteGroup
              ? isBannedPostGroupSession(selectedSession)
                ? t("group_management_config.member_no_talking.close-desc")
                : t("group_management_config.member_no_talking.open-desc")
              : t("group_management_config.member_no_talking.disabled-desc")
          }
        >
          <SettingSwitch
            selectedSession={selectedSession}
            type={SessionSettingsType.BANNED_POST}
            disabled={!allowMuteGroup}
            clsTag={[
              "pageclick|keycount|Xtbg_Msg_Setting_GroupManageMent|SetBandToPost_True",
              "pageclick|keycount|Xtbg_Msg_Setting_GroupManageMent|SetBandToPost_False"
            ]}
          />
        </GroupSettingItem>
        {/* 允许成员设置昵称 */}
        {/* {isFocusEnv() && ( */}
        <GroupSettingItem
          title={t("group_management_config.member_set_alias.title")}
          desc={
            isGroupSetAlias(selectedSession)
              ? t("group_management_config.member_set_alias.open-desc")
              : t("group_management_config.member_set_alias.close-desc")
          }
        >
          <SettingSwitch selectedSession={selectedSession} type={SessionSettingsType.SET_ALIAS} />
        </GroupSettingItem>
        {/* )} */}
        <GroupSettingItem
          title={t("group_management_config.member_card_view.title")}
          desc={
            isCardViewGroupSession(selectedSession)
              ? t("group_management_config.member_card_view.close-desc")
              : t("group_management_config.member_card_view.open-desc")
          }
        >
          <SettingSwitch
            selectedSession={selectedSession}
            type={SessionSettingsType.CARD_VIEW}
            clsTag={[
              "pageclick|keycount|Xtbg_Msg_Setting_GroupManageMent|SetCheck_True",
              "pageclick|keycount|Xtbg_Msg_Setting_GroupManageMent|SetCheck_False"
            ]}
          />
        </GroupSettingItem>
        {/* 按单位选择成员 */}
        {/* <GroupSettingItem
      title={t("group_management_config.visible_unit.title")}
      desc={
        isGroupVisibleUnit(selectedSession)
          ? t("group_management_config.visible_unit.open-desc")
          : t("group_management_config.visible_unit.close-desc")
      }
    >
      <SettingSwitch
        selectedSession={selectedSession}
        type={SessionSettingsType.VISIBLE_UNIT}
        clsTag={[
          "pageclick|keycount|Xtbg_Msg_Setting_GroupManageMent|SetSelect_False",
          "pageclick|keycount|Xtbg_Msg_Setting_GroupManageMent|SetSelect_True"
        ]}
      />
    </GroupSettingItem> */}
        {/* 显示成员单位名称 */}
        <GroupSettingItem
          title={t("group_management_config.chat_visible_unit.title")}
          desc={
            isGroupChatVisibleUnit(selectedSession)
              ? t("group_management_config.chat_visible_unit.close-desc")
              : t("group_management_config.chat_visible_unit.open-desc")
          }
        >
          <SettingSwitch
            selectedSession={selectedSession}
            type={SessionSettingsType.CHAT_VISIBLE_UNIT}
          />
        </GroupSettingItem>
        {/* 显示成员单位-职务名称 */}
        {/* 显示单位名称的情况下才展示该设置 */}
        {isGroupChatVisibleUnit(selectedSession) && (
          <GroupSettingItem
            title={t("group_management_config.visible_post.title")}
            desc={
              isGroupvisiblePost(selectedSession)
                ? t("group_management_config.visible_post.close-desc")
                : t("group_management_config.visible_post.open-desc")
            }
          >
            <SettingSwitch
              selectedSession={selectedSession}
              type={SessionSettingsType.VISIBLE_POST}
            />
          </GroupSettingItem>
        )}
        {/* 调整组成员人数上限 */}
        {!isTaskGroup && !isScheduleGroup && (
          <GroupSettingItem
            title={t("set-group-member-limit")}
            onClick={() => {}}
            clstag="pageclick|keycount|Xtbg_Msg_Setting_GroupManageMent|SetSubAdmin"
          >
            <Select
              value={renderLimitValue}
              onChange={async (val) => {
                // let opt = limitOpts.find((item: any) => item.limit === val);
                const groupInfo: any = selectedSession?.info;
                const { rosterSize } = groupInfo;
                if (val < rosterSize) {
                  message.info("无法选择，当前群内成员数量超过了切换人数上限");
                  return;
                }
                if (val > 0) {
                  const instance = ImService.getInstance();
                  const result = await instance.setGroupMax(selectedSession.id, val);
                  // const resultIntro = await instance.setGroupIntro(selectedSession.id, intro);
                  if (result) {
                    message.success("设置成功！");
                  } else {
                    message.success("设置失败！");
                  }
                } else {
                  message.info("上限设置有误");
                }
              }}
            >
              {limitOpts.map((opt: any, idx: number) => (
                <Select.Option key={idx} value={opt.limit}>
                  {opt.desc}
                </Select.Option>
              ))}
            </Select>
          </GroupSettingItem>
        )}
        {/* 添加移除组管理员 只有群主才可以操作 */}
        {canSetAdmin && (
          <GroupSettingItem
            title={t("group-admin")}
            onClick={setGroupAdminFn}
            clstag="pageclick|keycount|Xtbg_Msg_Setting_GroupManageMent|SetSubAdmin"
          >
            <span style={{ marginRight: 4 }}>{adminNum}</span>
            <IconFont
              type="iconjs_ilist_arrowright"
              className="group-management-icon-arrow"
              clstag="pageclick|keycount|Xtbg_Msg_Setting_GroupManageMent|SetSubAdmin"
            />
          </GroupSettingItem>
        )}
        {visibleSetAdmin && (
          <GroupSubAdmin visible={visibleSetAdmin} onCancel={() => setVisibleSetAdmin(false)} />
        )}
        {/* 转让群组 只有群主才可以操作 */}
        {canTransferGroupOwner && (
          <GroupSettingItem
            title={t("transfer-group-owner")}
            onClick={transferGroupAdmin}
            clstag="pageclick|keycount|Xtbg_Msg_Setting_GroupManageMent|TransferCreator"
          >
            <IconFont
              type="iconjs_ilist_arrowright"
              className="group-management-icon-arrow"
              clstag="pageclick|keycount|Xtbg_Msg_Setting_GroupManageMent|TransferCreator"
            />
          </GroupSettingItem>
        )}
        {/* 消息设置 */}
        <GrayLine title={t("group_management_config.group_message_time_setting")} />
        {/* 消息精确到秒显示 */}
        <GroupSettingItem
          title={t("group_management_config.show_msg_time.title")}
          desc={
            isGroupShowMsgTime(selectedSession)
              ? t("group_management_config.show_msg_time.close-desc")
              : t("group_management_config.show_msg_time.open-desc")
          }
        >
          <SettingSwitch
            selectedSession={selectedSession}
            type={SessionSettingsType.SHOW_MSG_TIME}
          />
        </GroupSettingItem>
        {/* 智能聚合 */}
        {canAIMergeDisabled && (
          <GroupSettingItem
            title={t("group_ai_merge")}
            desc={
              isGroupAIMerge(selectedSession)
                ? t("group_management_config.group_ai_merge.close-desc")
                : t("group_management_config.group_ai_merge.open-desc")
            }
          >
            <SettingSwitch selectedSession={selectedSession} type={SessionSettingsType.AI_MERGE} />
          </GroupSettingItem>
        )}
        {/* 智能回复 */}
        {/* <GroupSettingItem title={t("group_ai_reply")}>
          <SettingSwitch selectedSession={selectedSession} type={SessionSettingsType.AI_REPLY} />
        </GroupSettingItem> */}
        <GroupSettingItem
          title={t("group_management_config.msg_dong_read.title")}
          desc={
            isGroupShowMsgReply(selectedSession)
              ? t("group_management_config.msg_dong_read.close-desc")
              : t("group_management_config.msg_dong_read.open-desc")
          }
        >
          <SettingSwitch
            selectedSession={selectedSession}
            type={SessionSettingsType.MSG_DONG_READ}
          />
        </GroupSettingItem>
        {/* 加群设置 */}
        <GrayLine title={t("group_management_config.group_join_management")} />
        {/* 全员可邀请 */}
        <GroupSettingItem
          title={t("group_management_config.approval_rule.title")}
          desc={
            isIdentityApproveRuleGroupSession(selectedSession)
              ? t("group_management_config.approval_rule.close-desc")
              : t("group_management_config.approval_rule.open-desc")
          }
        >
          <SettingSwitch
            selectedSession={selectedSession}
            type={SessionSettingsType.APPROVAL_RULE}
            disabled={approvalRuleDisabled}
            clsTag={[
              "pageclick|keycount|Xtbg_Msg_Setting_GroupManageMent|InviteAvailability_True",
              "pageclick|keycount|Xtbg_Msg_Setting_GroupManageMent|InviteAvailability_False"
            ]}
          />
        </GroupSettingItem>
        <GrayLine title={t("group_management_config.group_safety")} />
        {crossAppSwitch("messageRecord") && !isCrossPlatformGroupSession(selectedSession) && (
          <GroupSettingItem
            title={t("group_record_clean")}
            onClick={() => {
              bus.emit("recordClean:open", true);
            }}
          >
            <IconFont type="iconjs_ilist_arrowright" className="group-management-icon-arrow" />
          </GroupSettingItem>
        )}
        {/* 组变更记录 */}
        <GroupSettingItem
          title={t("group_change_record")}
          onClick={() => {
            bus.emit("record:open", true);
          }}
        >
          <IconFont type="iconjs_ilist_arrowright" className="group-management-icon-arrow" />
        </GroupSettingItem>
        {/* 群可被搜索 跨平台群无此配置 */}
        {/* {!isCrossPlatformGroupSession(selectedSession) && (
              <GroupSettingItem
                  title={t('group_management_config.can_search.title')}
                  desc={t('group_management_config.can_search.desc')}
              >
                  <SettingSwitch
                      selectedSession={selectedSession}
                      type={SessionSettingsType.CAN_SEARCH}
                      disabled={canSearchDisabled}
                      clsTag={[
                          'pageclick|keycount|focus_chat_01_1615797500283|84',
                          'pageclick|keycount|focus_chat_01_1615797500283|85',
                      ]}
                  />
              </GroupSettingItem>
          )} */}
        {/* 加群需要群主验证 跨平台群无此配置 */}
        {/* {!isCrossPlatformGroupSession(selectedSession) && ( */}
        {/*    <GroupSettingItem */}
        {/*        title={t('group_management_config.need_verify.title')} */}
        {/*        desc={t('group_management_config.need_verify.desc')} */}
        {/*    > */}
        {/*        <SettingSwitch */}
        {/*            selectedSession={selectedSession} */}
        {/*            type={SessionSettingsType.NEED_VERIFY} */}
        {/*            disabled={needVerifyDisabled} */}
        {/*            clsTag={[ */}
        {/*                'pageclick|keycount|focus_chat_01_1615797500283|86', */}
        {/*                'pageclick|keycount|focus_chat_01_1615797500283|87', */}
        {/*            ]} */}
        {/*        /> */}
        {/*    </GroupSettingItem> */}
        {/* )} */}
      </Drawer>
      <GroupRecord />
    </>
  );
}

function mapStateToProps({ chat }: { chat: ChatState }) {
  return {
    groupRosters: chat.groupRosters,
    selectedSession: chat.selectedSession
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    async loadSessionMembers(data: { selectedSession: SessionProps }) {
      await dispatch({ type: "chat/loadSessionMembers", payload: data });
    },
    updateSessionData(data: { session: Session }) {
      dispatch({ type: "chat/updateSessionData", payload: data });
    },
    updateSelectedSession(data: { selectedSession: Session }) {
      dispatch({ type: "chat/updateSelectedSession", payload: data });
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(GroupManager);
